module.exports = __webpack_public_path__ + "img/coupon-popup-bg-hen.c6c4035e.png";